// Rental duration helpers shared across SlipShare pages.

export const DURATION_UNITS = [
  { unit: "daily", labelSingular: "day", labelPlural: "days", shortSuffix: "/day", price_field: "price_daily" },
  { unit: "weekly", labelSingular: "week", labelPlural: "weeks", shortSuffix: "/wk", price_field: "price_weekly" },
  { unit: "monthly", labelSingular: "month", labelPlural: "months", shortSuffix: "/mo", price_field: "price_per_month" },
  { unit: "yearly", labelSingular: "year", labelPlural: "years", shortSuffix: "/yr", price_field: "price_yearly" },
];

export const DURATION_MAP = Object.fromEntries(DURATION_UNITS.map((d) => [d.unit, d]));

export function availableDurations(dock) {
  if (!dock) return [];
  if (Array.isArray(dock.available_durations) && dock.available_durations.length) {
    return dock.available_durations.map((d) => ({ ...DURATION_MAP[d.unit], price: d.price }));
  }
  return DURATION_UNITS
    .filter((d) => Number(dock[d.price_field]) > 0)
    .map((d) => ({ ...d, price: Number(dock[d.price_field]) }));
}

export function cheapestDuration(dock) {
  const durs = availableDurations(dock);
  if (!durs.length) return null;
  return durs[0]; // daily is cheapest per-unit; ordered lowest→highest already
}

export function formatPrice(n) {
  const v = Number(n) || 0;
  return `$${v.toFixed(v % 1 === 0 ? 0 : 2)}`;
}
